export default __webpack_public_path__ + "static/media/about-us.1e5a3805.jpeg";